// extracted by css-extract-rspack-plugin
export default {"HeaderTitle":"hm6LV"};